<template>
    <div class="grid grid-cols-1 gap-x-4 gap-y-3 py-2">
        <BaseInputSelect
            v-model="formValues.classification"
            name="crs_declaration.classification"
            :options="crsClassificationOptions"
            :label="$t('crs_classification.company_classification')"></BaseInputSelect>
        <BaseInputText
            v-if="formValues.classification === 'active_stock_traded'"
            v-model="formValues.stock_exchange_name"
            name="crs_declaration.stock_exchange_name"
            :label="$t('crs_classification.stock_exchange_name')"></BaseInputText>
        <BaseInputText
            v-if="formValues.classification === 'active_stock_traded'"
            v-model="formValues.affiliate_stock_exchange_name"
            name="crs_declaration.affiliate_stock_exchange_name"
            :label="$t('crs_classification.affiliate_stock_exchange_name')"></BaseInputText>
    </div>
</template>

<script setup lang="ts">
import BaseInputText from '../../../../base/BaseInputText.vue'
import BaseInputSelect from '../../../../base/BaseInputSelect.vue'
import { useVModel } from '@vueuse/core'
import { CrsClassification, getLegalWidgetFormValidationRules, initializeLegalWidgetForm } from './forms'

const crsClassificationOptions = [
    {
        key: 'passive',
        label: 'Passive NFE',
    },
    {
        key: 'financial_institution',
        label: 'Financial-, - depository, custodial institution, or specified insurance company',
    },
    {
        key: 'investment_company',
        label: 'An investment company based in a non-participating country which is managed by another financial institution ',
    },
    {
        key: 'active_stock_traded',
        label: 'Active NFE – a company whose stock is regularly traded on an established securities exchange or a company that is an affiliate of such a company.',
    },
    {
        key: 'active_state_owned',
        label: 'Active NFE - a government/state-owned enterprise or central bank',
    },
    {
        key: 'active_international_organisation',
        label: 'Active NFE - an international organisation',
    },
    {
        key: 'active_other',
        label: 'Active NFE - other (e.g. a start-up NFE or a non-profit NFI)',
    },
]

const props = defineProps<{
    modelValue: CrsClassification
}>()
const emit = defineEmits(['update:modelValue'])

const formValues = useVModel(props, 'modelValue', emit)
initializeLegalWidgetForm(getLegalWidgetFormValidationRules('crs_declaration'))
</script>
